var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("div", {
    staticClass: "back",
    on: {
      click: _vm.backClick
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/back.png"),
      alt: ""
    }
  })]), _c("iframe", {
    attrs: {
      src: "https://guoyu-ai.rich-link.cn/dialogue_outer",
      frameborder: "0"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };